import { Skeleton } from "@/components/ui/skeleton";
import { BuscarSorteioVigenteDto } from "@/dtos/BuscarSorteioVigenteDto";
import SorteioService from "@/services/SorteioService";
import { useEffect, useState } from "react";
import { ResultadosPage } from "../Resultados";
import { Separator } from "@/components/ui/separator";
import { NavLink } from "react-router-dom";
import { CompraRapida } from "@/components/CompraRapida";

export function HomePage() {
    const [dadosSorteioVigente, setDadosSorteioVigente] = useState<BuscarSorteioVigenteDto>({} as BuscarSorteioVigenteDto);
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        async function buscarSorteioVigente() {
            setLoading(true)
            const result = await SorteioService.buscarSorteioVigente();
            setDadosSorteioVigente(result.Data);
            setLoading(false)
        }

        buscarSorteioVigente();
    }, [])


    return (
        <>
            <div className="mb-12">
                {
                    loading ? (
                        <div className="flex items-center">
                            <Skeleton className="h-80 bg-primary w-screen rounded-xl" />
                        </div>
                    ) : (
                        <div className="flex flex-col">
                            <div className="md:hidden m-5 flex flex-col justify-center items-center">
                                <img className="rounded-[5%]" src={dadosSorteioVigente.ImagemPremioApp} />
                            </div>

                            <div className="hidden m-5 md:flex flex-col justify-center items-center">
                                <NavLink to="/compra/titulos">
                                    <img className="rounded-lg" src={dadosSorteioVigente.ImagemPremio} />
                                </NavLink>
                            </div>

                            <CompraRapida />
                        </div>
                    )
                }

                <Separator className="mt-4" />
            </div>

            <h1 className="text-2xl justify-center text-center font-bold text-primary">Resultados</h1>

            <ResultadosPage exibirImagemSorteio={false} />
        </>
    )
}